var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "global-intro d-flex flex-column align-items-center text-center",
    class: _vm.textAlignement
  }, [_c('div', {
    staticClass: "col-12 col-lg-8"
  }, [_c('RegularTitle', {
    attrs: {
      "text": _vm.title.text,
      "color": _vm.title.color,
      "level": _vm.title.level
    }
  }), _vm._v(" "), _c('RegularSubtitle', {
    staticClass: "mb-3",
    attrs: {
      "text": _vm.subtitle.text,
      "color": _vm.subtitle.color,
      "level": _vm.subtitle.level
    }
  }), _vm._v(" "), _c('SimpleParagraph', {
    attrs: {
      "paragraph": _vm.simpleParagraph
    }
  }), _vm._v(" "), _vm.ctas.length ? _c('div', {
    staticClass: "cta-wrapper"
  }, _vm._l(_vm.ctas, function (cta, key) {
    return _c('Cta', _vm._b({
      key: key,
      staticClass: "d-flex d-md-inline-flex text-center text-md-left mt-3 mr-md-4",
      attrs: {
        "target": _vm.target
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, cta.tracking);
        }
      }
    }, 'Cta', cta.props, false));
  }), 1) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };